import { useState, useRef, useEffect } from 'react';

const CLIENTS = [
  { name: "L'Oréal",         logo: "loreal" },
  { name: "Garnier",          logo: "garnier" },
  { name: "Maybelline",       logo: "maybelline" },
  { name: "TRESemmé",         logo: "tresemme" },
  { name: "Dove",             logo: "dove" },
  { name: "Nexxus",           logo: "nexxus" },
  { name: "Dyson",            logo: "dyson" },
  { name: "Neutrogena",       logo: "neutrogena" },
  { name: "Kérastase",        logo: "kerastase" },
  { name: "Simple",           logo: "simple" },
  { name: "Novology",         logo: "novology" },
  { name: "Pond's",           logo: "ponds" },
  { name: "Enrich",           logo: "enrich" },
  { name: "Kinoko",           logo: "kinoko" },
  { name: "Matrix",           logo: "matrix" },
  { name: "Love Beauty & Planet", logo: "loveandbeauty" },
  { name: "Indulekha",        logo: "indulekha" },
  { name: "Redken",           logo: "redken" },
  { name: "Tira",             logo: "tira" },
  { name: "Sunsilk",          logo: "sunsilk" },
  { name: "NYX",              logo: "nyx" },
  { name: "CeraVe",           logo: "cerave" },
  { name: "Kohler",           logo: "kohler" },
  { name: "Olay",             logo: "olay" },
  { name: "Biolage",          logo: "biolage" },
  { name: "Trunativ",         logo: "trunativ" },
  { name: "Laneige",          logo: "laneige" },
  { name: "Paree",            logo: "paree" },
  { name: "Oppo",             logo: "oppo" },
  { name: "Vivo",             logo: "vivo" },
  { name: "Nykaa",            logo: "nykaa" },
  { name: "Myntra",           logo: "myntra" },
  { name: "Sugar Cosmetics",  logo: "sugarcosmetics" },
  { name: "Wow Skin Science", logo: "wowskinsci" },
  { name: "Puma India",       logo: "puma" },
];

function ClientBadge({ name, logo }) {
  const [imgFailed, setImgFailed] = useState(false);
  const showLogo = logo && !imgFailed;

  return (
    <span className="marquee-badge">
      <span className="marquee-logo-wrap">
        {showLogo ? (
          <img
            src={`/logos/${logo}.png`}
            alt={name}
            className="marquee-logo"
            onError={() => setImgFailed(true)}
            draggable={false}
          />
        ) : (
          <span className="marquee-logo-fallback">
            {name.replace(/[^a-zA-Z]/g, '').slice(0, 2).toUpperCase()}
          </span>
        )}
      </span>
      <span className="marquee-name-badge">{name}</span>
    </span>
  );
}

export default function Clients() {
  const trackRef = useRef(null);
  const posRef = useRef(0);
  const rafRef = useRef(null);
  const dragging = useRef(false);
  const lastX = useRef(0);

  const SPEED = 0.55; // px per animation frame

  // Continuous auto-scroll loop via rAF
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const step = () => {
      if (!dragging.current) {
        const half = track.scrollWidth / 2;
        posRef.current += SPEED;
        if (posRef.current >= half) posRef.current -= half;
        track.style.transform = `translateX(-${posRef.current}px)`;
      }
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  // Mouse drag
  const onMouseDown = (e) => {
    dragging.current = true;
    lastX.current = e.clientX;
  };
  const onMouseMove = (e) => {
    if (!dragging.current) return;
    const dx = lastX.current - e.clientX;
    lastX.current = e.clientX;
    const track = trackRef.current;
    if (!track) return;
    const half = track.scrollWidth / 2;
    posRef.current = ((posRef.current + dx) % half + half) % half;
    track.style.transform = `translateX(-${posRef.current}px)`;
  };
  const onMouseUp = () => { dragging.current = false; };

  // Touch swipe
  const onTouchStart = (e) => {
    dragging.current = true;
    lastX.current = e.touches[0].clientX;
  };
  const onTouchMove = (e) => {
    if (!dragging.current) return;
    const dx = lastX.current - e.touches[0].clientX;
    lastX.current = e.touches[0].clientX;
    const track = trackRef.current;
    if (!track) return;
    const half = track.scrollWidth / 2;
    posRef.current = ((posRef.current + dx) % half + half) % half;
    track.style.transform = `translateX(-${posRef.current}px)`;
  };
  const onTouchEnd = () => { dragging.current = false; };

  return (
    <section id="clients" data-testid="client-marquee-section" className="clients-section">
      <p className="clients-label">Trusted by leading brands</p>
      <div
        className="marquee-outer"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* Content is doubled so the loop is seamless */}
        <div ref={trackRef} className="marquee-track">
          {[...CLIENTS, ...CLIENTS].map((client, i) => (
            <ClientBadge key={i} {...client} />
          ))}
        </div>
      </div>
    </section>
  );
}
